import { render } from "./MatrixAuthorizedAccount.vue?vue&type=template&id=1fdc1422&scoped=true"
import script from "./MatrixAuthorizedAccount.vue?vue&type=script&lang=js"
export * from "./MatrixAuthorizedAccount.vue?vue&type=script&lang=js"

import "./MatrixAuthorizedAccount.vue?vue&type=style&index=0&id=1fdc1422&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fdc1422"]])

export default __exports__